export const DragTypes = {
	TILE: "TILE",
};

export const GRID_HEIGHT = 8;
export const GRID_WIDTH = 10;

export const GRID_COUNT = GRID_HEIGHT * GRID_WIDTH;
